import { COUNTRY_DEFAULTS, Language, type Country, type UiLocale } from '@acs/shared';

/**
 * The assistant language a new business starts with.
 *
 * An owner's FIRST business is where their account begins, so it starts in the
 * portal language they picked before signing up, when the assistant speaks it.
 * Later businesses, and a portal language the assistant does not speak
 * (Ukrainian), start from the country, as before. Either way it is only a
 * default: the owner confirms or changes it on the Assistant step.
 */
export function newBusinessLanguage(
  country: Country,
  uiLocale: UiLocale | undefined,
  firstBusiness: boolean,
): Language {
  const fromLocale = Language.safeParse(uiLocale);
  if (firstBusiness && fromLocale.success) return fromLocale.data;
  return COUNTRY_DEFAULTS[country].language;
}
